meedy.service('meedy.blobUtils', ['$window', '$document',
	function ($window, $document) {
		var self = this;
		
		this.saveAsPdf = function (blobOrString, fileName) {
			self.save(blobOrString, fileName, {type: 'application/pdf'});
		};
		
		this.save = function (blobOrString, fileName, config) {
			
			var file = new Blob([blobOrString], config);
			if ($window.navigator && $window.navigator.msSaveOrOpenBlob) {
				$window.navigator.msSaveOrOpenBlob(file, fileName);
			} else {
				var fileURL = $window.URL.createObjectURL(file);
				var link = document.createElement('a');
				link.href = fileURL;
				link.download = fileName;
				
				$document[0].body.appendChild(link);
				link.click();
				
				setTimeout(function() {
					// For Firefox it is necessary to delay revoking the ObjectURL
					$document[0].body.removeChild(link);
					$window.URL.revokeObjectURL(fileURL);
				}, 100);
			}
			
		}
	
	}
]);
